import(/* webpackMode: "eager" */ "/app/app/(pages)/faqs/page.tsx");
